import React, { useContext, useMemo, useState } from 'react';

import Alert from '@amzn/meridian/alert';
import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import Loader from '@amzn/meridian/loader';
import Row from '@amzn/meridian/row';

import { isNil } from 'lodash';
import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom';
import { DocumentRow } from 'src/components/Agreements/AgreementsTable/grid-types';
import { createDocumentRows } from 'src/components/Agreements/AgreementsTable/util-functions';
import { DocumentDetail } from 'src/components/Agreements/DocumentDetail/DocumentDetail';
import { listAllDocuments } from 'src/components/Agreements/Shared';
import { ROUTES } from 'src/constants/routes';
import { AppContext } from 'src/contexts/appContext';
import { useTitle } from 'src/hooks';
import { useAsyncEffect } from 'src/util/async';

export const DeepLinkViewer: React.FC = (props) => {
    const history = useHistory();
    const { userInfo } = useContext(AppContext);
    const { tenantId, documentId } = useParams<{ tenantId: string; documentId: string }>();
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | undefined>();
    const [documents, setDocuments] = useState<DocumentRow[]>([]);

    const document = useMemo(() => {
        return documents.find((document) => document.id === documentId);
    }, [documents]);

    useTitle(`Document: ${document?.friendlyName ?? document?.name ?? documentId}`);

    useAsyncEffect(async () => {
        setLoading(true);
        await listAllDocuments(userInfo.username, setErrorMessage)
            .then((documents) => createDocumentRows(documents, undefined, undefined))
            .then(setDocuments)
            .finally(() => setLoading(false));
    }, []);

    return (
        <Column width={'100%'}>
            {!isNil(errorMessage) && (
                <Alert type={'error'} onClose={() => setErrorMessage(undefined)}>
                    {errorMessage}
                </Alert>
            )}
            {!isNil(document) && (
                <DocumentDetail
                    tenantId={tenantId}
                    documentId={documentId}
                    data={document}
                    showPrefix={true}
                    setLoading={setLoading}
                    setErrorMessage={setErrorMessage}
                    onClose={() => history.push(ROUTES.AGREEMENTS.INDEX)}
                />
            )}
        </Column>
    );
};
